import React, { useMemo } from "react";
import { InputLabel, MenuItem, Select, makeStyles } from "@material-ui/core";
import LightTheme from "../theme/LightTheme";

interface Props {
  id: string;
  onChange: (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => void;
  options: { value: string; label: string }[];
  label: string;
  value?: string;
}

const useStyles = makeStyles({
  label: {
    marginTop: "10px",
    fontSize: "0.6rem",
    color: LightTheme.font.secondary.color,
  },
  select: {
    fontSize: "0.8rem",
    border: "none",
    backgroundColor: "transparent",
    color: LightTheme.font.secondary.color,
    width: "100%",
  },
  item: {
    minHeight: "25px",
    fontSize: "0.8rem",
  },
});

const CustomMaterialSelect = ({
  id,
  onChange,
  options,
  label,
  value,
}: Props) => {
  const classes = useStyles();
  const inputProps = useMemo(
    () => ({
      id,
    }),
    [id],
  );

  if (!value) {
    return null;
  }

  return (
    <>
      <InputLabel htmlFor={id} className={classes.label}>
        {label}
      </InputLabel>
      <Select
        value={value}
        defaultValue={value}
        onChange={onChange}
        className={classes.select}
        inputProps={inputProps}
      >
        {options.map((option) => (
          <MenuItem
            value={option.value}
            key={option.value}
            className={classes.item}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default CustomMaterialSelect;
